/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { dataRemovalRequestIndex } from '../../axios/dataRemovalRequestIndex'
import type {
	DataRemovalRequestIndexError,
	DataRemovalRequestIndexPathParams,
	DataRemovalRequestIndexResponse,
} from '../../types/DataRemovalRequestIndex'

export const dataRemovalRequestIndexQueryKey = (organisation: DataRemovalRequestIndexPathParams['organisation']) =>
	[{ url: '/organisations/:organisation/data-removal-requests', params: { organisation } }] as const

export type DataRemovalRequestIndexQueryKey = ReturnType<typeof dataRemovalRequestIndexQueryKey>

/** @see backend/nexus/modules/Campaign/Http/Controllers/DataRemovalRequestController.php DataRemovalRequestController::index */
export function dataRemovalRequestIndexQueryOptions(
	organisation: DataRemovalRequestIndexPathParams['organisation'],
	config?: AxiosRequestConfig,
) {
	return queryOptions<
		DataRemovalRequestIndexResponse,
		AxiosError<DataRemovalRequestIndexError>,
		DataRemovalRequestIndexResponse,
		DataRemovalRequestIndexQueryKey
	>({
		queryKey: dataRemovalRequestIndexQueryKey(organisation),
		queryFn: ({ signal }) => dataRemovalRequestIndex(organisation, { signal, ...config }).then(res => res.data),
		enabled: !!organisation,
	})
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/DataRemovalRequestController.php DataRemovalRequestController::index */
export function useDataRemovalRequestIndex<TSelectData = DataRemovalRequestIndexResponse>(
	organisation: DataRemovalRequestIndexPathParams['organisation'],
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					DataRemovalRequestIndexResponse,
					AxiosError<DataRemovalRequestIndexError>,
					TSelectData,
					DataRemovalRequestIndexQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<DataRemovalRequestIndexError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...dataRemovalRequestIndexQueryOptions(organisation),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/DataRemovalRequestController.php DataRemovalRequestController::index */
export function useDataRemovalRequestIndexSuspense<TSelectData = DataRemovalRequestIndexResponse>(
	organisation: DataRemovalRequestIndexPathParams['organisation'],
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					DataRemovalRequestIndexResponse,
					AxiosError<DataRemovalRequestIndexError>,
					TSelectData,
					DataRemovalRequestIndexQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<DataRemovalRequestIndexError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...dataRemovalRequestIndexQueryOptions(organisation),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
